import * as React from "react";
import { useDisclosure } from "@chakra-ui/react";
import { useIdleTimer } from "react-idle-timer";
import TimeoutModal from "../TimeoutModal";

/**
 * Idle Timer
 * Controls time delay for inactivity before displaying the TimeoutModal
 * @param {number} idleTimerSecs seconds before idle prompt
 * @return {JSX.Element}
 * @constructor
 */
function IdleTimer({ idleTimerSecs }) {
  const timeout = idleTimerSecs * 1000;
  const { isOpen, onClose, onOpen } = useDisclosure();

  const onIdle = () => {
    onOpen();
  };

  useIdleTimer({
    onIdle,
    timeout,
  });

  return (
    <TimeoutModal
      isOpen={isOpen}
      onOpen={onOpen}
      onClose={onClose}
      timeout={20}
    />
  );
}

export { IdleTimer };
